var exports = {
  "k": "x93eb46d8--bbaf12--container",
};

module.exports = exports;
